import script from "./ConfirmationEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationEmail.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationEmail.vue?vue&type=style&index=0&id=1862b0db&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1862b0db"]])

export default __exports__